import HeadLayout from "../../components/layout/RootLayout";

const pageChildren = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
          My Projects
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          Explore my portfolio of web and software development projects
        </p>
      </div>
   
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {/* Upcoming project card */}
        <div className="group relative rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 flex flex-col min-h-[280px]">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/0 dark:from-blue-400/10 dark:to-blue-400/0 group-hover:opacity-80 transition-opacity duration-300"></div>
          <div className="flex flex-col h-full items-center justify-center p-6 relative z-10">
            <div className="bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400  rounded-full shadow-md mb-4 group-hover:scale-110 transition-transform duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">Coming Soon</h3>
            <p className="text-gray-600 dark:text-gray-300 text-center">New exciting project in development</p>
          </div>
        </div>

        {/* Checkey project card */}
        <a href="/projects/checkey" className="block group">
          <div className="relative rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 flex flex-col min-h-[280px]">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/0 dark:from-blue-400/10 dark:to-blue-400/0 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="flex flex-col h-full items-center justify-center p-6 relative z-10">
              <div className="relative w-20 h-20 mb-4 overflow-hidden rounded-full bg-white dark:bg-gray-800 shadow-md group-hover:scale-110 transition-transform duration-300">
                <img className="w-full h-full object-cover object-center" src="/checkey/icon-128.png" alt="Checkey" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">Checkey</h3>
              <p className="text-gray-600 dark:text-gray-300 text-center">Find the best game key prices in one place</p>
            </div>
          </div>
        </a>
        
        {/* Parque de Invierno project card */}
        <a href="/projects/parque-invierno" className="block group">
          <div className="relative rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 flex flex-col min-h-[280px]">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/0 dark:from-blue-400/10 dark:to-blue-400/0 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="flex flex-col h-full items-center justify-center p-6 relative z-10">
              <div className="relative w-20 h-20 mb-4 overflow-hidden rounded-full bg-white dark:bg-gray-800 shadow-md group-hover:scale-110 transition-transform duration-300">
                <img className="w-full h-full object-cover object-center" src="/parque-invierno/parque.jpeg" alt="Parque de Invierno" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">Parque de Invierno</h3>
              <p className="text-gray-600 dark:text-gray-300 text-center">An immersive winter-themed experience</p>
            </div>
          </div>
        </a>
        
        {/* Turist AI project card */}
        <a href="/projects/turistai" className="block group">
          <div className="relative rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 flex flex-col min-h-[280px]">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/0 dark:from-blue-400/10 dark:to-blue-400/0 group-hover:opacity-80 transition-opacity duration-300"></div>
            <div className="flex flex-col h-full items-center justify-center p-6 relative z-10">
              <div className="relative w-20 h-20 mb-4 overflow-hidden rounded-full bg-white dark:bg-gray-800 shadow-md group-hover:scale-110 transition-transform duration-300">
                <img className="w-full h-full object-cover object-center" src="/turistai/logo.png" alt="Turist AI" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300">Turist AI</h3>
              <p className="text-gray-600 dark:text-gray-300 text-center">AI-powered travel recommendations</p>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

function Projects() {
  return (
    <HeadLayout 
      title="Projects | Leonardo Capone" 
      description="Explore Leonardo Capone's portfolio of software development projects, web applications, and other digital creations." 
      keywords="projects, portfolio, web development, software development, Leonardo Capone, Checkey, Parque de Invierno, Turist AI"
    >
      {pageChildren()}
    </HeadLayout>
  );
}

export default Projects;
